import { VegaChip, VegaCodeBlock, VegaDivider, VegaFlex, VegaFont, VegaGrid } from '@globalpayments/vega-react';

import DetailsModal from '../../detailsModal';
import { ComponentStatusCheck } from '../../../types/componentStatus';
import { formatCodeBlock } from '../../../utility/formatCodeBlock';
import { statusColor } from './statusHelpers';
import styles from './ComponentStatusDetailsModal.module.css';

interface ComponentStatusDetailsModalProps {
  component?: ComponentStatusCheck;
  open: boolean;
  onClose: () => void;
}

/** Displays detailed component health status selected from either responsive status view. */
const ComponentStatusDetailsModal = ({ component, open, onClose }: ComponentStatusDetailsModalProps) => (
  <DetailsModal
    ariaDescribedBy="ComponentStatusCheckDescription"
    ariaLabelledBy="ComponentStatusCheckResult"
    contentGap="size-8"
    modalTitle={component ? `${component.name} Status Details` : 'Component Status Check Details'}
    onClose={onClose}
    open={open}
    width={{ default: '90%', M: '75%' }}>
    {component?.statusResult && (
      <VegaChip
        chipType="status"
        size="small"
        statusColor={statusColor(component.statusResult.status)}
        text={component.statusResult.status}
        variant="outlined"
      />
    )}
    <VegaDivider />
    <VegaGrid column={{ default: 1, M: 5 }} gap="size-8">
      <VegaFlex direction="col" gap="size-4">
        <VegaFont as="span" color="text-secondary" variant="font-field-label-em">
          Build Version
        </VegaFont>
        <VegaFont as="span" variant="font-p2-short">
          {component?.statusResult?.buildVersion}
        </VegaFont>
      </VegaFlex>
      <VegaFlex className={styles.buildDate} direction="col" gap="size-4">
        <VegaFont as="span" color="text-secondary" variant="font-field-label-em">
          Build Date
        </VegaFont>
        <VegaFont as="span" variant="font-p2-short">
          {component?.statusResult?.buildDate}
        </VegaFont>
      </VegaFlex>
      <VegaFlex direction="col" gap="size-4">
        <VegaFont as="span" color="text-secondary" variant="font-field-label-em">
          Status Code
        </VegaFont>
        <VegaFont as="span" variant="font-p2-short">
          {component?.statusResult?.responseStatusCodeDisplay}
        </VegaFont>
      </VegaFlex>
      <VegaFlex direction="col" gap="size-4">
        <VegaFont as="span" color="text-secondary" variant="font-field-label-em">
          Duration
        </VegaFont>
        <VegaFont as="span" variant="font-p2-short">
          {component?.statusResult?.durationMS} ms
        </VegaFont>
      </VegaFlex>
    </VegaGrid>
    <VegaDivider />
    <VegaFlex direction="col" gap="size-8">
      <VegaFont as="span" color="text-secondary" variant="font-field-label-em">
        Details
      </VegaFont>
      <VegaCodeBlock readOnly showCopyButton value={formatCodeBlock(component?.statusResult?.details ?? '')} />
    </VegaFlex>
  </DetailsModal>
);

export default ComponentStatusDetailsModal;
